import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
let applicationsAreaInstances = [];
let mobile = window.innerWidth <= 1023;
console.log('mobile', mobile);

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
    const isMobile = window.innerWidth <= 1023;
    if (isMobile !== mobile) {
        mobile = isMobile;
        handleMobileGridInit();
    }

    destroy();
});

function handleSwiperInit() {
    const blocks = document.querySelectorAll('.applications-areas-block');

    blocks.forEach(block => {
        const type = block.dataset.type;
        if (applicationsAreaInstances.length === 0) {
            const container = block.querySelector('.swiper');
            if (!container) return;

            const swiper = new Swiper(container, {
                modules: [Navigation, Pagination],
                spaceBetween: '16px',
                slidesPerView: 1,
                navigation: {
                    nextEl: block.querySelector('.swiper-button-next'),
                    prevEl: block.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: block.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
                on: {
                    init: function() {
                        this.pagination.update();
                    },
                    slideChange: function() {
                        this.pagination.update();
                    },
                },
            });

            if (type === 'grid') {
                applicationsAreaInstances.push(swiper);    
                destroy();        
            }
        }
    });
}

function handleMobileGridInit() {
    const blocks = document.querySelectorAll('.applications-areas-block');

    blocks.forEach(block => {
        const type = block.dataset.type;
        if (type === 'grid') {
            const container = block.querySelector('.swiper');
            if (!container) return;

            const swiper = new Swiper(container, {
                modules: [Navigation, Pagination],
                spaceBetween: '16px',
                slidesPerView: 1,
                navigation: {
                    nextEl: block.querySelector('.swiper-button-next'),
                    prevEl: block.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: block.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
                on: {
                    init: function() {
                        this.pagination.update();
                    },
                    slideChange: function() {
                        this.pagination.update();
                    },
                },
            });

            applicationsAreaInstances.push(swiper);    
        }
    });
}

function destroy() {
    const isMobile = window.innerWidth <= 1023;

    if (!isMobile && applicationsAreaInstances.length > 0) {
        applicationsAreaInstances.forEach((swiper) => {
            if (typeof swiper.destroy === 'function') {
                swiper.destroy(true, true);
            }
        });
        applicationsAreaInstances = [];
    }
}
